"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLambdaEventSource = void 0;
// https://gist.github.com/jeshan/52cb021fd20d871c56ad5ce6d2654d7b
function getLambdaEventSource(event) {
    var _a;
    if (event.Records && event.Records[0].cf)
        return "isCloudfront";
    if (event.configRuleId && event.configRuleName && event.configRuleArn)
        return "isAwsConfig";
    if (event.Records && event.Records[0].eventSource === "aws:codecommit")
        return "isCodeCommit";
    if (event.authorizationToken === "incoming-client-token")
        return "isApiGatewayAuthorizer";
    if (event.StackId && event.RequestType && event.ResourceType)
        return "isCloudFormation";
    if (event.Records && event.Records[0].eventSource === "aws:ses")
        return "isSes";
    if (event.httpMethod && ((_a = event.pathParameters) === null || _a === void 0 ? void 0 : _a.proxy))
        return "isApiGatewayAwsProxy";
    if (event.httpMethod && event.headers)
        return "isApiGateway";
    if (event.source === "aws.events")
        return "isScheduledEvent";
    if (event.awslogs && event.awslogs.data)
        return "isCloudWatchLogs";
    if (event.Records && event.Records[0].EventSource === "aws:sns")
        return "isSns";
    if (event.Records && event.Records[0].eventSource === "aws:dynamodb")
        return "isDynamoDb";
    if (event.records && event.records[0].approximateArrivalTimestamp)
        return "isKinesisFirehose";
    if (event.records && event.deliveryStreamArn && event.deliveryStreamArn.startsWith("arn:aws:kinesis:"))
        return "isKinesisFirehose";
    if (event.eventType === "SyncTrigger" && event.identityId && event.identityPoolId)
        return "isCognitoSyncTrigger";
    if (event.Records && event.Records[0].eventSource === "aws:kinesis")
        return "isKinesis";
    if (event.Records && event.Records[0].eventSource === "aws:s3")
        return "isS3";
    if (event.Records && event.Records[0].eventSource === "aws:sqs")
        return "isSqs";
    if (event.operation && event.message)
        return "isMobileBackend";
    return "isUnknown";
}
exports.getLambdaEventSource = getLambdaEventSource;
//# sourceMappingURL=lambda-event-source.js.map